{
  "{platform} version {version} · update {update}": "Versie {version} voor {platform} · update {update}",
  "{platform} version {version}": "Versie {version} voor {platform}",
  "Delete my account, all personal data, and all video files streamed or uploaded online from EventLive servers": "Mijn account, alle persoonsgegevens en alle gestreamde of geüploade videobestanden verwijderen van de servers van EventLive",
  "Delete your Account? THIS ACTION IS IRREVERSIBLE": "Je account verwijderen? DIT KAN NIET ONGEDAAN WORDEN GEMAAKT",
  "You have {count} prepaid event. It's used automatically when you create an event.": {
    "one": "Je hebt {count} vooraf betaald evenement. Het wordt automatisch gebruikt als je een evenement aanmaakt.",
    "other": "Je hebt {count} vooraf betaalde evenementen. Er wordt er automatisch een gebruikt als je een evenement aanmaakt."
  },
  "My Video Wall": "Mijn Videomuur",
  "Download Everything": "Alles downloaden",
  "Update Profile": "Profiel bijwerken",
  "View Invoices and Manage Subscription": "Facturen bekijken en abonnement beheren",
  "Reset Password": "Wachtwoord opnieuw instellen",
  "Contact Support": "Contact opnemen met support",
  "Review EventLive": "EventLive beoordelen",
  "Delete Account": "Account verwijderen",
  "Sign Out": "Uitloggen",
  "{team}'s Team": "Team van {team}",
  "Team": "Team",
  "Over {limit} in all": "Meer dan {limit} in totaal",
  "Ticketed: no limit": "Met tickets: geen limiet",
  "{hours} in all": "{hours} in totaal",
  "MMMM YYYY": "MMMM YYYY",
  "{month} (so far)": "{month} (tot nu toe)",
  "Couldn't load this month. Please try again.": "Deze maand kon niet worden geladen. Probeer het opnieuw.",
  "How many hours of your videos people watched each month, live and replay. Each event includes {limit} viewer-hours; ticketed events have no limit.": "Hoeveel uur mensen per maand naar je video's hebben gekeken, live en via de opname. Elk evenement bevat {limit} kijkuren; evenementen met tickets hebben geen limiet.",
  "Viewer-hours are shown to business accounts.": "Kijkuren zijn zichtbaar voor zakelijke accounts.",
  "Couldn't load viewer-hours. Please try again later.": "De kijkuren konden niet worden geladen. Probeer het later opnieuw.",
  "No viewer-hours yet. They're updated every hour, within an hour of people watching.": "Nog geen kijkuren. Ze worden elk uur bijgewerkt, binnen een uur nadat mensen hebben gekeken.",
  "Counted every hour from the video our CDN delivered, on every player. Months are in UTC, and an event's hours count in the month people watched. Test events aren't included.": "Elk uur geteld op basis van de video die ons CDN heeft geleverd, op elke speler. Maanden zijn in UTC, en de uren van een evenement tellen mee in de maand waarin mensen keken. Testevenementen tellen niet mee.",
  "{extra} over {limit} this month": "{extra} boven {limit} deze maand",
  "{extra} extra viewer-hours on {count} event over {limit}": {
    "one": "{extra} extra kijkuren bij {count} evenement boven {limit}",
    "other": "{extra} extra kijkuren bij {count} evenementen boven {limit}"
  }
}
